import { tv } from "tailwind-variants";
import { Flex, SkeletonLoader } from "@bdo/cornerstone-ui";
import type { WorkflowInstance } from "@/types";

interface WorkflowSidebarHeaderProps {
  workflow: WorkflowInstance | undefined;
  isLoading: boolean;
}

export function WorkflowSidebarHeader({
  workflow,
  isLoading,
}: Readonly<WorkflowSidebarHeaderProps>) {
  const title = workflow?.workflowInstanceName ?? "";
  const workflowDefinition =
    workflow?.workflowDefinition.workflowDefinitionName ?? "";

  const styles = tv({
    slots: {
      titleContainer: "text-lg font-bold flex justify-between items-center",
      title: "text-mono-dark overflow-hidden text-ellipsis whitespace-nowrap",
      workflowDefinition:
        "text-mono-dark overflow-hidden text-ellipsis whitespace-nowrap",
    },
  });

  const {
    titleContainer: titleContainerStyle,
    title: titleStyle,
    workflowDefinition: workflowDefinitionStyle,
  } = styles();

  return (
    <Flex direction="column">
      {isLoading ? (
        <div className="flex flex-col gap-sm">
          <SkeletonLoader height="21px" width="100%" />
          <SkeletonLoader height="21px" width="60px" />
        </div>
      ) : (
        <>
          <span className={titleContainerStyle()}>
            <span
              className={titleStyle()}
              data-testid="workflow-title"
              title={title}
            >
              {title}
            </span>
          </span>
          <span
            className={workflowDefinitionStyle()}
            data-testid="workflow-definition-name"
            title={workflowDefinition}
          >
            {workflowDefinition}
          </span>
        </>
      )}
    </Flex>
  );
}
